function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useState, useEffect } from 'react';
import fetch from '@rd-web-markets/shared/dist/services/Fetcher';
import { request } from '@rd-web-markets/shared/dist/services/request';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import serviceMethods from './service_methods';
import { buildService } from './service';
const api = buildService('/users', {
  only: ['all', 'create', 'update', 'delete']
});
export const UserService = {
  useFetchUsersForSelect: function () {
    let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    const [users, setUsers] = useState([]);
    const fetchUsers = useErrorHandling(useCallback(async () => {
      const response = await UserService.all(type);
      setUsers(response.users.map(user => ({
        value: user.id,
        label: user.name
      })));
    }, [type]));
    useEffect(() => {
      fetchUsers();
    }, [fetchUsers]);
    return [users, setUsers];
  },
  all: type => {
    return fetch("/api/users/?type=".concat(type), request.get);
  },
  get: id => {
    return fetch("/api/users/".concat(id), request.get);
  },
  getAuthorizationPath: () => {
    return fetch('/api/users/authorize_path', request.get);
  },
  initiateAuthorization: (authorizationPath, authenticityToken) => {
    return fetch(authorizationPath, _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        authenticity_token: authenticityToken
      })
    })).then(data => {
      console.log(data);
    });
  },
  logout: () => {
    return fetch('/api/users/sign_out.json', request.post);
  },
  delete: id => {
    return fetch("/api/users/".concat(id), request.delete);
  },
  update: user => {
    return fetch("/api/users/".concat(user.id), _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        user
      })
    }));
  },
  create: user => {
    return fetch('/api/users/', _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        user
      })
    }));
  },
  confirm: user => {
    return fetch('/api/users/confirm.json', _objectSpread(_objectSpread({}, request.post), {}, {
      body: JSON.stringify({
        user
      })
    }));
  },
  getCurrent: function () {
    return fetch('/api/users/current_session.json', request.get);
  },
  generateOtpBackupCodes: function () {
    return fetch('/api/users/otp_backup_codes.json', request.post);
  },
  validateConfirmationToken: token => {
    return fetch("/api/users/confirm.json?user[confirmation_token]=".concat(token), request.get);
  },
  sendInviteEmail: userId => {
    return fetch("/api/users/send_invite_email/".concat(userId, ".json"), request.post);
  },
  updatePassword: user => {
    return fetch('/api/users/password.json', _objectSpread(_objectSpread({}, request.put), {}, {
      body: JSON.stringify({
        user
      })
    }));
  },
  sendPasswordResetInstructions: user => {
    return fetch('/api/users/password', {
      method: 'POST',
      body: JSON.stringify({
        user
      })
    });
  },
  signIn: user => {
    return fetch('/api/users/sign_in', {
      method: 'POST',
      body: JSON.stringify({
        user
      })
    });
  },
  useFetch(_ref) {
    let {
      setLoading,
      fetchImediately = true
    } = _ref;
    const [users, setUsers, fetchUsers] = serviceMethods.useFetch({
      callback: useCallback(async queryParams => await api.all(queryParams), []),
      setLoading,
      fetchImediately
    });
    return [users, setUsers, fetchUsers];
  },
  useCreate(_ref2) {
    let {
      onSuccess,
      onError,
      onFinally,
      setLoading
    } = _ref2;
    const createModel = serviceMethods.useCreate({
      setLoading,
      onSuccess,
      onError,
      onFinally,
      callback: useCallback(async user => {
        await api.create(user);
      }, [])
    });
    return createModel;
  },
  useUpdate(_ref3) {
    let {
      onSuccess,
      onError,
      onFinally,
      setLoading
    } = _ref3;
    const update = serviceMethods.useUpdate({
      setLoading,
      onSuccess,
      onError,
      onFinally,
      callback: useCallback(async user => {
        if (!user) {
          return null;
        }
        return await api.update(user.id, {
          user
        });
      }, [])
    });
    return update;
  }
};